export default "__VITE_ASSET__COWerUX$__"